module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "web-interactives-dashboard-ui",
    "version": "1"
  },
  "createInteraction": {
    "name": "create interaction",
    "class": "interaction",
    "properties": {
      "source": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string"
      },
      "event": {
        "type": "string"
      },
      "succeeded": {
        "type": "boolean",
        "isOptional": true
      },
      "templatePath": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "web-interactives-dashboard-ui",
    "version": "1"
  },
  "dashboardInteraction": {
    "name": "dashboard interaction",
    "class": "interaction",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string"
      },
      "event": {
        "type": "string"
      },
      "succeeded": {
        "type": "boolean",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "web-interactives-dashboard-ui",
    "version": "1"
  },
  "dashboardUsage": {
    "name": "dashboard usage",
    "class": "usage",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string"
      },
      "event": {
        "type": "string"
      },
      "succeeded": {
        "type": "boolean",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "web-interactives-dashboard-ui",
    "version": "1"
  },
  "detailsInteraction": {
    "name": "details interaction",
    "class": "interaction",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string"
      },
      "event": {
        "type": "string"
      },
      "succeeded": {
        "type": "boolean",
        "isOptional": true
      },
      "to": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "web-interactives-dashboard-ui",
    "version": "1"
  },
  "detailsUsage": {
    "name": "details usage",
    "class": "usage",
    "properties": {
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string"
      },
      "event": {
        "type": "string"
      },
      "succeeded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "web-interactives-dashboard-ui",
    "version": "1"
  }
};